/* istanbul ignore file */
import { NotFound } from 'secondstep-components'

export default () => <NotFound location={window.location} />
